export default "__VITE_ASSET__DEveGv1E__"